import type { LanguageCode } from '@/types';

interface LanguageSwitchProps {
  current: LanguageCode;
  supported: LanguageCode[];
  onChange: (lang: LanguageCode) => void;
}

export function LanguageSwitch({ current, supported, onChange }: LanguageSwitchProps) {
  return (
    <div className="flex gap-1 kiosk:gap-[1vw]">
      {supported.map((code) => (
        <button
          key={code}
          type="button"
          onClick={() => onChange(code)}
          className={`text-[0.65rem] kiosk:text-kiosk-xs px-2 py-1.5 kiosk:px-[2vw] kiosk:py-[1.2vw] min-h-[32px] kiosk:min-h-0 rounded-full border transition-colors duration-150 ${
            code === current
              ? 'bg-kiosk-accent border-kiosk-accent text-white font-semibold'
              : 'border-kiosk-border text-kiosk-text hover:border-kiosk-accent'
          }`}
        >
          {code.toUpperCase()}
        </button>
      ))}
    </div>
  );
}
